import AppointmentFormDetail from '../AppointmentFormDetail';

export default {
  data() {
    return {
      patient: {},
      appointment: {}
    }
  },

  components: {
    AppointmentFormDetail
  },

  created() {
    this.appointment = this.$route.params['appointment'];
    this.patient = this.appointment.patient;
  }
}


// WEBPACK FOOTER //
// ./src/views/Appointment/js/appointment-edit.js